import React from 'react';
import Icon from '@material-ui/core/Icon';
import moment from 'moment'

class DateCustomInput extends React.Component {
    isDateEnd = () => {
        //const date = moment().format('DD.MM.YYYY')
        var dt = this.props.value.split('.')
        var date = moment(dt[2] + '-' + dt[1] + '-' + dt[0])
        var now = moment();

        //return  moment(date).isAfter(this.props.value)
        return  now >= date
    }

    isTemplate = () => {
        return  this.props.type === 'template'
    }
    render () {
        return (
            <div className={`dates__wrap ${this.isDateEnd() && "dates__wrap_end"} ${this.isTemplate() && "dates__wrap_template"}`}>
                <div className="dates__label">
                    <Icon>access_time</Icon>
                    {this.props.label}:
                </div>
                <button
                    className="dates__btn"
                    onClick={this.props.onClick}>
                    {
                        this.props.value ? this.props.value : 'None'
                    }
                </button>

                <button className='dates__remove-btn' onClick={() => this.props.removeDate(this.props.index)}>
                    <Icon>close</Icon>
                </button>
            </div>

        )
    }
}


export default DateCustomInput;


// WEBPACK FOOTER //
// ./src/components/DateCustomInput.js